(($) => {
  const body = $('body')
  const modal = $('.cpb-custom-modal');
  const builder = $('#product-builder');
  
  $('.personalize-it--js').on('click', function() {
      if(modal.hasClass('opened')) {
        closeModal()
      } else {
        openModal()
      }
  })
  modal.on('click', function(e) {
    if(e.target != modal[0]) return
    closeModal()
  })
  modal.find('.cpb-custom-modal__close').on('click', function() {
    closeModal()
  })

  function openModal() {
    modal.addClass('open-start')
    setTimeout(() => {
      modal.addClass('opened')
      modal.removeClass('open-start')
    })
    body.addClass('cpb-custom-opened');
    document.body.dispatchEvent(new CustomEvent('cpb-modal-open'))
    // window.scrollTo(0,100);
    // window.scrollTo(0,500);
    builder[0].scrollTo(0,0);
  }

  function closeModal() {
    document.body.dispatchEvent(new CustomEvent('cpb-modal-close'));
    modal.addClass('close-start')
    setTimeout(() => {
      modal.removeClass('close-start')
      modal.removeClass('opened')
      body.removeClass('cpb-custom-opened')
    }, 200)    
  }
})(jQuery);

(($) => {  
  function changeFontInit() {
    let toChange, fontSelector
    
    update()
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', update)
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', update)
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', (e) => {
      const categoryId = fontSelector.attr('data-category-id')
      if(e.detail.newLayers?.[0]?.category !== categoryId) return
      const product = CPB.getStore().getState().Product
      const layer = product.layers.find(layer => layer.category === categoryId)
      if(!layer) return
      let fontName
      product.panels.find(panel => {
        if(panel.id === layer.panel) {
          panel.categories.find(category => {
            if(category.id === layer.category) {
              fontName = category.options[0].option.data.value
            }
            return false
          })
        }
        return false
      })
      setFont(fontName)
    })
    
    function update() {
      toChange = $('.change-font--js textarea, .change-font--js input')
      fontSelector = $('.font-selector--js').eq(0)   
    }

    function setFont(fontName) {
      toChange.attr('style', `font-family: "${fontName}";`)
    }
  }

  const getState = {
    categoryId(el) {
      return el.getAttribute('data-category-id') || false
    },
    panelCategoryByCategoryId(id) {
      if(!id) return {panel: false, category: false};
      const panels = CPB.getStore().getState().Product.panels;
      let category = false;
      const panel = panels.find(panel => {
        category = panel.categories.find(category => category.id === id);
        return category;
      });
      return category ? {panel, category} : {panel: false, category: false};
    },
    panelCategoryByCategoryElement(el) {
      return this.panelCategoryByCategoryId(this.categoryId(el));
    }
  }

  const fontsThumbnails = {
    fontsInProduct: false,
    init() {
      this.loadFonts();
      this.update();
      if(CPB.getStore().getState().App.settings.layout !== 'col-list') {
        document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', this.update.bind(this));
        document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', this.update.bind(this));
      }    
    },
    update() {
      const that = this;
      const fontCategories = $('.cpb-category-fontFamily:not([data-font-thumbnails="true"])');
      fontCategories.each(function() {
        const category = $(this);
        category.find('.cpb-category-options-container').hide();
        const objects = getState.panelCategoryByCategoryElement(this);
        const container = $('<div class="cpb-custom-category-options-container">');
        that.fontsInProduct.forEach(font => {
          const optionEl = $('<button class="cpb-custom-option-font" data-font="' + font + '" style="font-family: ' + font + '">').text(font);
          if(objects.category.options[0].option.data.defaultSelectValue === font) optionEl.addClass('active');
          container.append(optionEl);
          optionEl.on('click', function() {
            if(!api.frontend) return;
            let option = objects.category.options[0];
            option.option.data.value = font;
            api.frontend.updateOptions({
              panel: objects.panel,
              category: objects.category,
              options: [option]
            });
            container.find('.cpb-custom-option-font').removeClass('active');
            optionEl.addClass('active');
          });
        });
        category.find('.cpb-category-content').append(container);
        category.attr('data-font-thumbnails', true)
      });
    },
    loadFonts() {
      const state = CPB.getStore().getState();
      const fontsInProduct = state.App.settings.fonts.available;
      this.fontsInProduct = fontsInProduct;
      const customFonts = state.Global.fonts;
      const customAvailable = customFonts.filter(font => fontsInProduct.includes(font.name));
      const customAvailableNames = customAvailable.map(font => font.name);
      const builtInAvailable = fontsInProduct.filter(fontName => !customAvailableNames.includes(fontName));
      if(builtInAvailable.length) {
        let style = '<style>@import url("https://fonts.googleapis.com/css2?';
        builtInAvailable.forEach(font => {
          style += 'family=' + font.replace(/ /i, '+') + '&';
        });
        style += 'display=swap");</style>';
        $('body').append($(style));
      }
      let styleCustom = '<style>'
      customAvailable.forEach(font => {
        new FontFace(font.name, 'url(' + font.file + ')').load().then(function(loaded_face) {
          document.fonts.add(loaded_face);
        });
        styleCustom += `@font-face {
          font-family: ${font.name};
          src: url(${font.file});
        }`
      });
      styleCustom += '</style>'
      $('body').append($(styleCustom))
    }
  }

  const showPanelIndexes = {
    panelsContainer: false,
    tabList: false,
    init() {
      this.panelsContainer = $('.cpb-panels-container')
      this.tabList = this.panelsContainer.find('.react-tabs__tab-list')
      this.update()
      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', this.update.bind(this))
      document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', this.update.bind(this))
    },
    update() {
      const panels = this.tabList.find('.react-tabs__tab')
      let activeIndex = 0
      for(let i = 0; i < panels.length; i++) {
        if(panels.eq(i).hasClass('cpb-active')) {
          activeIndex = i
          break
        }
      }
      this.panelsContainer.attr('data-cpb-custom-panel-index', activeIndex).attr('data-cpb-custom-panel-index-from-end', panels.length - 1 - activeIndex)
    }
  }

  function customPrice() {
    const price = $('.cpb-product-price').eq(0)
    const customPriceWrapper = $('<div class="cpb-custom-product-price-wrapper">')
    const customPrice = $('<div class="cpb-custom-product-price">')

    customPrice.text(price.text())
    
    new MutationObserver(() => {
      customPrice.text(price.text())
    }).observe(price[0], {subtree: true, characterData: true})

    customPriceWrapper.append($('<div class="cpb-custom-price-message">').text('Prix total de la personnalisation'), customPrice)
    $('.cpb-product-actions').last().after(customPriceWrapper)
    $('#product-builder').attr('data-custom-product-price', true)
  }

  function modifyProductInCartInit() {
    if(window.location.search.indexOf('&modifyProduct=') === -1) return;
    var keyId = window.location.search.split('&modifyProduct=')[1];
    keyId = keyId.split('&')[0];
    var addToCartBtn = $('.cpb-add-to-cart-button');
    // addToCartBtn.find('span').html('Update Cart');
    addToCartBtn.on('click', function() {
      $.get('/cart/change.js', {
        'id': keyId,
        'quantity': 0
      });
    });
  }

  function removeUnderscores() {
    fixTitles()
    fixSummary()
    fixSteps()
    
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function() {
      setTimeout(function() {
        fixTitles()
        fixSummary()
      })
    })
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function() {
      setTimeout(function() {
        fixTitles()
        fixSummary()
      })
    })

    function fixSummary() {
      $('.cpb-selection-summary-list-item-category-title:not([data-underscore-removed="true"]), .cpb-selection-summary-list-item-panel:not([data-underscore-removed="true"]').each(function() {
        const $this = $(this)
        rewrite($this)
        $this.attr('data-underscore-removed', true)
      })
    }
    function fixTitles() {
      $('.cpb-category-title__inner:not([data-underscore-removed="true"])').each(function() {
        const $this = $(this)
        rewrite($this.find('span'))
        $this.attr('data-underscore-removed', true)
      })
    }
    function fixSteps() {
      $('.react-tabs__tab  ').each(function() {
        rewrite($(this))
      })
    }
    function rewrite(el) {
      const tmp = el.text()
      if(tmp[0] !== '_') return
      el.text(tmp.substring(1))
    }
  }

  function cartDrawer() {
    const cartDrawer = $('cart-drawer')[0]
    const bubble = $('#cart-icon-bubble')[0]
    document.addEventListener('cpb-add-to-cart', open)
    
    async function open() {
      const response = await fetch('/')
      const pageInText = await response.text()
      cartDrawer.innerHTML = cartDrawer.getSectionInnerHTML(pageInText, '#CartDrawer')     
      bubble.innerHTML = cartDrawer.getSectionInnerHTML(pageInText, '#cart-icon-bubble')   
      cartDrawer.open()
    }
  }


  function changeLayout() {
    if ($('.cpb-preview-container').length > 0 && $('.cpb-layout').length) {
      const layout = $('.cpb-layout');
      const title = $('.cpb-product-title');
      const priceWrapper = $('.cpb-custom-product-price-wrapper');
      
      const customMain = $('<div class="cpb-custom-main"></div>');
      
      layout.children().appendTo(customMain);
      layout.append(customMain);
      layout.prepend(title);
      layout.append(priceWrapper);
      
      layout.attr('custom-layout', true);
    } else {
      window.requestAnimationFrame(changeLayout);    
    }
  }
  

  let api = {}
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    CPB.FrontendApi().then(Api => {api.frontend = new Api()})
    showPanelIndexes.init()
    fontsThumbnails.init()
    changeFontInit()
    customPrice()
    modifyProductInCartInit()
    removeUnderscores()
    cartDrawer()
    changeLayout();
  })
})(jQuery);

const addCssVars = () => {
  const updateCssVars = () => {
    const layout = document.querySelector('.cpb-layout');
    const title = document.querySelector('.cpb-product-title');
    if (title) {
      let titleHeight;

      if (title.clientHeight) {
        titleHeight = title.clientHeight;
      } else {
        let titlePaddingBlock = +window.getComputedStyle(title).paddingTop.replace(/\D/img, '') + +window.getComputedStyle(title).paddingBottom.replace(/\D/img, '');
        let titleLineHeight = +window.getComputedStyle(title).lineHeight.replace(/\D/img, '');
        titleHeight = titlePaddingBlock + titleLineHeight;
      }
      
      layout.style.setProperty('--title-height', titleHeight + 'px');
    }  
  }

  updateCssVars();
  document.body.addEventListener('cpb-modal-open', updateCssVars);
  document.body.addEventListener('cpb-modal-close', updateCssVars);
  window.addEventListener('resize', updateCssVars);
}

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', addCssVars);



















